import { render } from "./InstallmentOverdueState.vue?vue&type=template&id=1bbfd766"
import script from "./InstallmentOverdueState.vue?vue&type=script&lang=js"
export * from "./InstallmentOverdueState.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__